export default "__VITE_ASSET__e823c0ae__"